import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import {
  GetCategoryMenuListURL,
  AddDishesProductURL,
} from "../../assets/api/BaseURL";
import LoadingModal from "../../loader/LoadingModal";
import Select from "react-select";
import Notification from "../other/Notification";
import { useToast } from "../../../context/ToastContext";

const AddProduct = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const productImageRef = useRef(null);
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [menuList, setMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [productImage, setProductImage] = useState("");
  const maxImageSize = 1024 * 1024;
  const maxImageWidth = 500;
  const maxImageHeight = 500;
  const [product, setProduct] = useState({
    menu_id: "",
    name: "",
    price: "",
    proprice: "",
    tax: "",
    tax_type: "",
    status: true,
    picture: "",
    product_type: "",
    top_rated: false,
    best_seller: false,
    most_ordered: false,
    dine_in: false,
    delivery: false,
    pick_up: false,
    is_addon: false,
    is_foreign: 0,
    feature: false,
    isVariant: false,
    minQuantity: "1",
    preparation_time: "5",
    description: "",
    packaging_charges: "",
  });

  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleTagInputChange = (e) => {
    setInputValue(e.target.value);
    setError("");
    setSuccess("");
  };

  const handleInputKeyPress = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      setTags([...tags, inputValue.trim()]);
      setInputValue("");
      setError("");
      setSuccess("");
    }
  };

  const handleTagClick = (tagIndex) => {
    const newTags = [...tags];
    newTags.splice(tagIndex, 1);
    setTags(newTags);
    setError("");
    setSuccess("");
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleDishesProductsClick = (e) => {
    e.preventDefault();
    navigate("/view_products");
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const isValidNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    if (type === "checkbox") {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: checked,
      }));
      setError("");
      setSuccess("");
    } else if (type === "radio" && parseInt(value) === 3) {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: value,
        delivery: false,
        pick_up: false,
      }));
      setError("");
      setSuccess("");
    } else {
      setProduct((prevProduct) => ({
        ...prevProduct,
        [name]: value,
      }));
      setError("");
      setSuccess("");
    }
  };

  const handleSelectMenu = (selectedOption) => {
    setSelectedMenu(selectedOption);
    setError("");
    setSuccess("");
  };

  function isImageSizeValid(file) {
    if (file && file.size) {
      return file.size <= maxImageSize;
    }
    return false;
  }

  function isImageDimensionsValid(file) {
    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      return new Promise((resolve) => {
        image.onload = () => {
          const width = image.width;
          const height = image.height;

          const isValidDimensions =
            width <= maxImageWidth && height <= maxImageHeight;

          resolve(isValidDimensions);
        };
      });
    }

    return false;
  }

  const handleAddProduct = async (e) => {
    e.preventDefault();

    if (selectedMenu === null) {
      setError("Menu/Category cannot be empty");
      setSuccess("");
    } else if (product.name === "") {
      setError("Product Name cannot be empty");
      setSuccess("");
    } else if (product.product_type === "") {
      setError("Item Type cannot be empty");
      setSuccess("");
    } else if (product.preparation_time === "") {
      setError("Preparation Time cannot be empty");
      setSuccess("");
    } else if (product.price === "") {
      setError(" Price cannot be empty");
      setSuccess("");
    } else if (!isValidNumber(product.price)) {
      setError("Please enter a valid   Price");
      setSuccess("");
    } else if (product.proprice && !isValidNumber(product.proprice)) {
      setError("Please enter a valid Offer Price");
      setSuccess("");
    } else if (product.proprice && parseFloat(product.proprice) <= 0) {
      setError("Offer Price should be greater than 0");
      setSuccess("");
    } else if (
      product.proprice &&
      parseFloat(product.proprice) > parseFloat(product.price)
    ) {
      setError("Offer Price cannot be greater than Base Price");
      setSuccess("");
    } else if (
      product?.tax === null ||
      product?.tax === undefined ||
      String(product.tax).trim() === ""
    ) {
      setError("Tax Rate cannot be empty");
    }
    else if (!/^\d+(\.\d+)?$/.test(product.tax)) {
      setError("Tax Rate must be a valid number");
      setSuccess("");
    } else if (parseFloat(product.tax) < 0 || parseFloat(product.tax) > 100) {
      setError("Tax Rate must be between 0 and 100");
      setSuccess("");
    } else if (product.tax_type === "") {
      setError("Tax Type cannot be empty");
      setSuccess("");
    } else if (
      !product.dine_in &&
      !product.delivery &&
      !product.pick_up &&
      !product.is_addon
    ) {
      setError("Select atleast one service type");
      setSuccess("");
    } else if (product.minQuantity && !isValidNumber(product.minQuantity)) {
      setError("Please enter a valid Minimum Order Quantity");
      setSuccess("");
    } else if (!(parseInt(product.minQuantity) > 0)) {
      setError("Please enter a valid Minimum Order Quantity");
      setSuccess("");
    } else if (
      product.packaging_charges &&
      !isValidNumber(product.packaging_charges)
    ) {
      setError("Please enter a valid Packaging Fee");
      setSuccess("");
    } else if (productImage && !isImageSizeValid(productImage)) {
      setError(`Image size cannot be greater than ${maxImageSize / 1024}kb`);
      productImageRef.current.value = "";
      setProductImage("");
      setSuccess("");
    } else if (productImage && !(await isImageDimensionsValid(productImage))) {
      setError(
        `Image Dimensions cannot be greater than ${maxImageWidth}*${maxImageHeight}`
      );
      productImageRef.current.value = "";
      setProductImage("");
      setSuccess("");
    } else {
      const dataToSend = new FormData();
      dataToSend.append("menu_id", selectedMenu.value);
      dataToSend.append("name", product.name);
      dataToSend.append("price", product.price);
      dataToSend.append("proprice", product.proprice);
      dataToSend.append("tax_percent", product.tax);
      dataToSend.append("tax_type", product.tax_type);
      dataToSend.append("tags", tags.join(", "));
      dataToSend.append("status", product.status ? 1 : 0);
      dataToSend.append(
        "picture",
        productImage ? productImage : product.picture
      );
      dataToSend.append("product_type", product.product_type);
      dataToSend.append("top_rated", product.top_rated ? 1 : 0);
      dataToSend.append("best_seller", product.best_seller ? 1 : 0);
      dataToSend.append("most_ordered", product.most_ordered ? 1 : 0);
      dataToSend.append("dine_in_service", product.dine_in ? 1 : 0);
      dataToSend.append("delivery_service", product.delivery ? 1 : 0);
      dataToSend.append("pick_up_service", product.pick_up ? 1 : 0);
      dataToSend.append("is_addon", product.is_addon ? 1 : 0);
      dataToSend.append("is_foreign", product.is_foreign);
      dataToSend.append("min_order_quantity", product.minQuantity);
      dataToSend.append("feature", product.feature ? 1 : 0);
      dataToSend.append("preparation_time", product.preparation_time);
      dataToSend.append("description", product.description);
      dataToSend.append("packaging_charges", product.packaging_charges);

      try {
        const response = await axios({
          method: "post",
          url: AddDishesProductURL,
          data: dataToSend,
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200 && response.data.message) {
          setError("");
          setSuccess(response.data.message);
          setProduct({
            menu_id: "",
            name: "",
            price: "",
            proprice: "",
            tax: "",
            tax_type: "",
            status: true,
            picture: "",
            product_type: "",
            top_rated: false,
            best_seller: false,
            most_ordered: false,
            dine_in: false,
            delivery: false,
            pick_up: false,
            is_addon: false,
            feature: false,
            isVariant: false,
            minQuantity: "1",
            preparation_time: "5",
            description: "",
            packaging_charges: "",
            is_foreign: 0,
          });
          setTags([]);
          setInputValue("");
          setSelectedMenu(null);
          setProductImage("");
          productImageRef.current.value = "";
          if (product.isVariant) {
            localStorage.setItem("productID", response.data.id);
            setTimeout(() => {
              navigate("/manage_variant");
            }, 3000);
          }
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setSuccess("");
        } else {
          setError(error.message);
          setSuccess("");
        }
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);

  useEffect(() => {
    if (localStorage.getItem("currencySymbol")) {
      setCurrencySymbol(localStorage.getItem("currencySymbol"));
    }
  }, []);

  useEffect(() => {
    if (token) {
      async function getMenuList() {
        setIsLoading(true);
        try {
          const response = await axios.get(GetCategoryMenuListURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data.data) {
            const modifiedData = response.data.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setMenuList(modifiedData);
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
        setIsLoading(false);
      }
      getMenuList();
    }
  }, [token, addToast]);

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="view_products" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Menu Items</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-sm-flex justify-content-between align-items-start mb-2">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    Add Menu Item
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-danger mb-0 me-0"
                                    onClick={handleDishesProductsClick}
                                  >
                                    <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                                    Go Back
                                  </span>
                                </div>
                              </div>
                              <form className="forms-sample">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div className="row">
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label>Product Table</label>
                                      <div className="d-flex gap-3">
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_foreign"
                                            id="indianRadio"
                                            value={0}
                                            checked={product.is_foreign === 0}
                                            onChange={(e) =>
                                              setProduct((prev) => ({
                                                ...prev,
                                                is_foreign: Number(e.target.value),
                                              }))
                                            }
                                          />
                                          <label className="form-check-label" htmlFor="indianRadio">
                                            Local
                                          </label>
                                        </div>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="is_foreign"
                                            id="foreignerRadio"
                                            value={1}
                                            checked={product.is_foreign === 1}
                                            onChange={(e) =>
                                              setProduct((prev) => ({
                                                ...prev,
                                                is_foreign: Number(e.target.value),
                                              }))
                                            }
                                          />
                                          <label className="form-check-label" htmlFor="foreignerRadio">
                                            International
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Menu/Category
                                        <span className="text-danger">*</span>
                                      </label>
                                      <Select
                                        options={menuList}
                                        value={selectedMenu}
                                        onChange={handleSelectMenu}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Name
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Product Name"
                                        name="name"
                                        value={product.name}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Item Type
                                        <span className="text-danger">*</span>
                                      </label>

                                      <div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="veg"
                                            name="product_type"
                                            value="0"
                                            checked={
                                              parseInt(product.product_type) ===
                                              0
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="veg"
                                          >
                                            Veg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="nonVeg"
                                            name="product_type"
                                            value="1"
                                            checked={
                                              parseInt(product.product_type) ===
                                              1
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="nonVeg"
                                          >
                                            Non-Veg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="egg"
                                            name="product_type"
                                            value="2"
                                            checked={
                                              parseInt(product.product_type) ===
                                              2
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="egg"
                                          >
                                            Egg
                                          </label>
                                        </div>

                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            id="alcohol"
                                            name="product_type"
                                            value="3"
                                            checked={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            onChange={handleInputChange}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="alcohol"
                                          >
                                            Alcohol
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Preparation Time(Minutes)
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="preparation_time"
                                        value={product.preparation_time}
                                        onChange={handleInputChange}
                                      >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="15">15</option>
                                        <option value="20">20</option>
                                        <option value="25">25</option>
                                        <option value="30">30</option>
                                        <option value="35">35</option>
                                        <option value="40">40</option>
                                        <option value="45">45</option>
                                        <option value="50">50</option>
                                        <option value="55">55</option>
                                        <option value="60">60</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Price
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Price"
                                          name="price"
                                          value={product.price}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>Offer Price </label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Offer Price"
                                          name="proprice"
                                          value={product.proprice}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Tax Rate(%)
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div className="input-group">
                                        <input

                                          className="form-control"
                                          placeholder="Enter Tax Rate"
                                          name="tax"
                                          value={product.tax}
                                          onChange={handleInputChange}
                                          min="0"
                                          max="100"
                                          step="0.01"
                                          onKeyDown={(e) => {
                                            // Prevent entering invalid characters
                                            if (e.key === '-' || e.key === 'e') {
                                              e.preventDefault();
                                            }
                                          }}
                                          onInput={(e) => {
                                            let value = parseFloat(e.target.value);
                                            if (value > 100) {
                                              e.target.value = 100;
                                              setProduct((prev) => ({ ...prev, tax: "100" }));
                                            }
                                            if (value < 0) {
                                              e.target.value = 0;
                                              setProduct((prev) => ({ ...prev, tax: "0" }));
                                            }
                                          }}
                                        />
                                        <span className="input-group-text">
                                          %
                                        </span>
                                      </div>

                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Tax Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="tax_type"
                                        value={product.tax_type}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Select Tax Type
                                        </option>
                                        <option value="0">Exclude</option>
                                        <option value="1">Include</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group togglecss">
                                      <label>Status</label>
                                      <div
                                        className={`button r ${product.status ? "active" : ""
                                          }`}
                                        id="button-1"
                                      >
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          name="status"
                                          checked={product.status}
                                          onChange={handleInputChange}
                                        />
                                        <div className="knobs"></div>
                                        <div className="layer"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Service Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="dine_in"
                                            checked={product.dine_in}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Dine In
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="delivery"
                                            disabled={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            checked={product.delivery}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Delivery
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="pick_up"
                                            disabled={
                                              parseInt(product.product_type) ===
                                              3
                                            }
                                            checked={product.pick_up}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Pick Up
                                          </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name="is_addon"
                                            checked={product.is_addon}
                                            onChange={handleInputChange}
                                          />
                                          <label className="form-check-label">
                                            Is Addon
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>
                                        Minimum Order Quantity
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Minimum Order Quantity"
                                        name="minQuantity"
                                        value={product.minQuantity}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <label>Packaging Fee</label>
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Packaging Fee"
                                          name="packaging_charges"
                                          value={product.packaging_charges}
                                          onChange={handleInputChange}
                                        />
                                        <span className="input-group-text">
                                          {currencySymbol}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  {/* <div className="col-12">
                                    <div className="form-group">
                                      <label>Tags</label>
                                      <div id="tags">
                                        {tags.map((tag, index) => (
                                          <span
                                            key={index}
                                            onClick={() =>
                                              handleTagClick(index)
                                            }
                                          >
                                            {tag}
                                          </span>
                                        ))}
                                        <input
                                          type="text"
                                          className=""
                                          value={inputValue}
                                          placeholder="Add a tag & hit Enter"
                                          onChange={handleTagInputChange}
                                          onKeyDown={handleInputKeyPress}
                                        />
                                      </div>
                                    </div>
                                  </div> */}
                                  {/* <div className="col-12">
                                    <div className="form-group">
                                      <label>Description</label>
                                      <textarea
                                        className="form-control"
                                        placeholder="Enter Description"
                                        name="description"
                                        value={product.description}
                                        onChange={handleInputChange}
                                      ></textarea>
                                    </div>
                                  </div> */}
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-4">
                                        <div className="form-group">
                                          <label>Item Image</label>
                                          <input
                                            className="form-control"
                                            type="file"
                                            id="formFile"
                                            accept=".jpeg, .jpg, .png"
                                            ref={productImageRef}
                                            onChange={(e) =>
                                              setProductImage(e.target.files[0])
                                            }
                                          />
                                          <p style={{ color: 'red' }}>Recommended size: 200 × 200 px
                                            <br />Maximum size: 1024 × 1024 px (up to 1 MB)
                                            <br />Supported formats: JPG, JPEG, PNG
                                            <br />This image is displayed on the QR ordering screen.</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div className="form-group">
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="isVariant"
                                          checked={product.isVariant}
                                          onChange={handleInputChange}
                                        />
                                        <label className="form-check-label">
                                          Manage Variant(s)
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="col-4">
                                    <div className="form-group">
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          name="feature"
                                          checked={product.feature}
                                          onChange={handleInputChange}
                                        />
                                        <label className="form-check-label">
                                          Feature
                                        </label>
                                      </div>
                                    </div>
                                  </div> */}
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleAddProduct}
                                >
                                  Submit
                                </button>
                                <button
                                  className="btn btn btn-secondary"
                                  onClick={handleDishesProductsClick}
                                >
                                  Cancel
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />

          <Notification />
        </>
      )}
    </>
  );
};

export default AddProduct;